import styled from 'styled-components'
import { composeTheme } from '../../utils/compose-theme'
import fonts from '../../tokens/fonts'
import { defaultTheme } from '../../theming/data/defaultTheme'
import colors from '../../tokens/colors'
import border from '../../tokens/border'
import typography from '../../tokens/typography'
import margin from '../../tokens/layout/margin'

export const Container = styled.div`
  max-width: 3.2rem;
  max-height: 3.2rem;
  width: 100%;
  height: 100%;
  aspect-ratio: 1/1;
`

export const SpinnerWrapper = styled.div.attrs((props) => composeTheme(props))`
  border: ${border.width.widthThick} solid ${colors.neutralColorHighDark};
  border-bottom-color: ${(props) => props.theme.brandColors.primaryPure};
  border-radius: ${border.radius.radiusCircular};
  display: flex;
  animation: rotation 1s linear infinite;
  width: 100%;
  height: 100%;
  &.is-label {
    margin: ${margin.spacingNone} ${margin.spacingXxs};
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`
export const Label = styled.div.attrs((props) => composeTheme(props))`
  text-align: center;
  font-family: ${fonts.inter};
  font-size: ${typography.fontSize.fontSizeXxs};
  font-style: normal;
  font-weight: ${typography.fontWeight.fontWeightSemiBold};
  line-height: ${(props) => props.theme.lineHeight};
  color: ${(props) => props.theme.brandColors.sideMenuFontColor};
  margin-top: ${margin.spacingXxxs};
`
SpinnerWrapper.defaultProps = defaultTheme
Label.defaultProps = defaultTheme
